import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Loader2, MailCheck } from "lucide-react";
import { toast } from "sonner";
import clientApi from "@/lib/clientApi";
import { useLang } from "@/context/LanguageContext";

export default function ClientForgotPasswordPage() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await clientApi.post("/client/forgot-password", { email });
      setSent(true);
    } catch {
      toast.error(t("portal.resetGenericError"));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-radial-gold grid place-items-center px-4">
      <div className="w-full max-w-md card-dark p-8 sm:p-10 gold-glow text-center" data-testid="client-forgot-password-card">
        {sent ? (
          <>
            <div className="w-14 h-14 mx-auto mb-4 grid place-items-center rounded-full bg-[var(--gold)]/15 border border-[var(--gold)]/30">
              <MailCheck size={22} className="text-[var(--gold)]" />
            </div>
            <h1 className="font-display text-xl font-bold text-white mb-2">{t("portal.checkEmail")}</h1>
            <p className="text-white/60 text-sm">
              {t("portal.resetSentNote").replace("{email}", email)}
            </p>
          </>
        ) : (
          <>
            <h1 className="font-display text-xl font-bold text-white mb-2">{t("portal.resetTitle")}</h1>
            <p className="text-white/60 text-sm mb-6">{t("portal.resetSubtitle")}</p>
            <form onSubmit={submit} className="space-y-4 text-left">
              <div>
                <label className="text-xs uppercase tracking-widest text-white/55 mb-1.5 block">{t("contact.email")}</label>
                <div className="relative">
                  <Mail size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-[var(--gold)]" />
                  <input
                    required
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="input-dark pl-10"
                    data-testid="forgot-password-email"
                  />
                </div>
              </div>
              <button type="submit" disabled={submitting} className="btn-gold w-full justify-center" data-testid="forgot-password-submit">
                {submitting && <Loader2 size={16} className="animate-spin" />}
                {t("portal.sendResetLink")}
              </button>
            </form>
          </>
        )}
        <Link to="/portal/login" className="inline-block mt-6 text-xs text-white/50 hover:text-[var(--gold)] transition">
          {t("portal.backToSignIn")}
        </Link>
      </div>
    </div>
  );
}
